import { Component } from '@angular/core';

@Component({
	template: `
    <h1>Page Not Found!</h1>
    `
})
export class PageNotFoundComponent { }
